import(/* webpackMode: "eager" */ "/home/runner/work/toronto-parks-atlas/toronto-parks-atlas/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["SubmitPhotoForm"] */ "/home/runner/work/toronto-parks-atlas/toronto-parks-atlas/src/app/contribute/photo/[slug]/submit-form.tsx");
